export const analyticsSurfaces = {
  mainSite: "main_site",
  observatory: "observatory",
} as const;
